import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "self-center" };
const _hoisted_2 = { class: "self-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_item_section = _resolveComponent("q-item-section");
    const _component_q_item = _resolveComponent("q-item");
    const _component_router_link = _resolveComponent("router-link");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_app_multi_colored_icon = _resolveComponent("app-multi-colored-icon");
    const _component_q_list = _resolveComponent("q-list");
    const _component_q_menu = _resolveComponent("q-menu");
    return (_openBlock(), _createElementBlock("div", null, [
        _renderSlot(_ctx.$slots, "button", {}, () => [
            _createElementVNode("div", {
                class: _normalizeClass(["row cursor-pointer q-px-sm text-weight-bold", _ctx.btnClass])
            }, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Browse Spaces')), 1),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_q_icon, {
                        name: "keyboard_arrow_down",
                        size: "22px"
                    })
                ])
            ], 2)
        ]),
        _createVNode(_component_q_menu, {
            offset: _ctx.mainMenuOffset,
            style: { "width": "220px" },
            modelValue: _ctx.showMenu,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.showMenu) = $event))
        }, {
            default: _withCtx(() => [
                _createVNode(_component_q_list, null, {
                    default: _withCtx(() => [
                        (_ctx.isOwner)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: {
                                    name: 'Admin Dashboard'
                                }
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_item, {
                                        clickable: "",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.showMenu = false))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, {
                                                side: "",
                                                class: "pr-smd"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_q_icon, {
                                                        name: "support_agent",
                                                        color: "primary",
                                                        size: "25px"
                                                    })
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_q_item_section, null, {
                                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                    _createTextVNode(" Admin Panel ")
                                                ])),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        _createVNode(_component_q_separator),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchRoutes, (value, appInd) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: value.display_name
                            }, [
                                _createVNode(_component_router_link, {
                                    target: _ctx.styleType === 'desktop' ? '_blank' : '',
                                    to: value.routerData
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_q_item, {
                                            clickable: "",
                                            class: "q-py-md"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_item_section, {
                                                    side: "",
                                                    class: "q-pr-sm"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_app_multi_colored_icon, {
                                                            icon: value.app,
                                                            "icon-size": 24
                                                        }, null, 8, ["icon"])
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_item_section, null, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(value.display_name), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                    _: 2
                                }, 1032, ["target", "to"]),
                                _withDirectives(_createVNode(_component_q_separator, null, null, 512), [
                                    [_vShow, Number(appInd) < _ctx.searchRoutes.length - 1]
                                ])
                            ]));
                        }), 128))
                    ]),
                    _: 1
                })
            ]),
            _: 1
        }, 8, ["offset", "modelValue"])
    ]));
}
